/* eslint new-cap: 0 */
import BaseClass from '../base-class';
import Event from './Event';
import EventDate from './EventDate';
import EventLocation from './EventLocation';
import User from './User';
import Role from './Role';
import Company from './Company';
import Whitelabel from './Whitelabel';
import MetaData from './MetaData';
import Collapse from './Collapse';
import Product from './Product';
import PGroup from './ProductGroup';
import Ticket from './Ticket';
import Template from './Template';
import Shop from './Shop';
import TicketReservation from './TicketReservation';
import OrderManager from './OrderManager';
import AccessProduct from './AccessProduct';
import PaymentMethod from './PaymentMethod';
import Order from './Order';
import Coupon from './Coupon';
import CouponCode from './CouponCode';
import ShopCoupon from './ShopCoupon';
import CompoundTicket from './CompoundTicket';
import Tracker from './Tracker';
import ScannerType from './ScannerType';
import ScannerInstance from './ScannerInstance';
import Export from './Export';
import Payout from './Payout';
import ProductReservationPool from './ProductReservationPool';
import ArbitrarySplit from './ArbitrarySplit';
import CashFlow from './CashFlow';

import ErrorService from '../services/ErrorReporter';
import helpers from '../services/helpers';
import LaravelValidationRules from '../services/LaravelValidationRules';
import Locales from '../services/locales';
import Sortable from '../services/sortable';
import filters from '../filters';
import Store from 'angular-storage';
import GlobalProductReservation from './GlobalProductReservation';

/**
 * @ngdoc overview
 * @name eventix.common.models
 * @description Models used throughout the shop and dashboard
 */
const models = angular.module('eventix.common.models',[
    BaseClass, ErrorService, Sortable, Locales, Store,
    LaravelValidationRules, filters, helpers
]);

Event(models);
Coupon(models);
CouponCode(models);
ShopCoupon(models);
AccessProduct(models);
EventDate(models);
EventLocation(models);
User(models);
Role(models);
Company(models);
CompoundTicket(models);
Tracker(models);
Whitelabel(models);
MetaData(models);
Product(models);
Ticket(models);
Collapse(models);
Template(models);
Shop(models);
PGroup(models);
TicketReservation(models);
Order(models);
OrderManager(models);
PaymentMethod(models);
ScannerType(models);
ScannerInstance(models);
Export(models);
Payout(models);
ProductReservationPool(models);
ArbitrarySplit(models);
CashFlow(models);
GlobalProductReservation(models)

export default models.name;
